import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function generatePdf(cadastros, selectEquipe) {
  let title_pdf = 'Problemas ativos'
  let titlePdfSave = utils.methods.titlePdf(
    'Problemas ativos',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Condições ou alergias'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'DUM',
    'DESFECHO',
    'PROBLEMA',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.dum = cadastros[i].dum
    obj.desfecho = utils.methods.formatDate(cadastros[i].dt_desfecho)
    if (cadastros[i].dt_desfecho == null) {
      obj.problema = 'Pré-natal aberto'
    } else {
      obj.problema = 'Outro'
    }
    let documentoText = ''
    if (cadastros[i].id !== null && cadastros[i].id !== undefined) {
      documentoText += `CPF / CNS ${cadastros[i].id}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
export function printTableRow(item) {
  if (
    (item.situacao === 'Ativo' || item.situacao === null) &&
    item.atual == '0'
  ) {
    return 'red'
  } else {
    return 'green'
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      (item.situacao === 'Ativo' || item.situacao === null) &&
      item.atual == '0'
    ) {
      return true
    }
    return false
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      (item.situacao === 'Ativo' || item.situacao === null) &&
      item.atual == '0'
    ) {
      return false
    }
    return true
  })
  return filtro
}
export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  Dum: 'dum',
  Desfecho: {
    field: 'dt_desfecho',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Problema: {
    field: 'dt_desfecho',
    callback: (value) => {
      if (value !== null && value !== '' && value !== undefined) {
        return 'Outro'
      }
      return 'Pré-natal aberto'
    },
  },
}
